export const LocalStorageKeys = {
    REQUESTED_PATH: 'requestedPath',
}